/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { Component, Fragment } from 'react';
import NavMenu from './NavMenu';
import { USE_NEW_NAV } from '../Context/ShiftsContext';
import ProfileDropdown from './Profile/ProfileDropdown';
import { connect } from 'react-redux'
import { updateUser, fetchAuditsIfNeeded, updateUserProfile, setAppState, toggleNav, closeChat } from '../actions'
import UpgradeModal from './Profile/UpgradeModal'
import { Icon, ContextualMenu, DefaultButton, Modal, IconButton, PrimaryButton, Spinner, SpinnerSize, MessageBar, MessageBarType } from '@fluentui/react';
import Snackbar from '../UiKit/Toast/Toast';
import axios from 'axios';
import { AUTH_CONFIG } from '../Auth/auth0-variables';
import $ from 'jquery'
import Quizs from './Profile/Quizs';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
import ClockinOptions from './Timesheets/ClockinOptions';
import { withRouter } from 'react-router-dom';
import { Chat24Regular } from '@fluentui/react-icons';
import ShiftsContext from '../Context/ShiftsContext'
import { Tooltip } from "@fluentui/react-components";
import { Hamburger } from "@fluentui/react-nav-preview";
import ProfileImagePicker from './Profile/ProfileImagePicker';
import DemoTourRoot from './DemoTour';
import Intercom from '@intercom/messenger-js-sdk';
const signalR = require("@microsoft/signalr");

const INTERCOM_APP_ID = 'iuq42ztl';

// Calendly event link — replace with your real event URL.
const CALENDLY_URL = 'https://calendly.com/teamslyapp-support/30min';
const CALENDLY_WIDGET_JS = 'https://assets.calendly.com/assets/external/widget.js';
const CALENDLY_WIDGET_CSS = 'https://assets.calendly.com/assets/external/widget.css';

const msg = css`
.ms-MessageBar{
background: rgb(253, 231, 233);
.ms-MessageBar-content {
    padding: 5px 15px;
    .ms-MessageBar-innerText{
        font-size: 14px;
    }
}
}
`;

class Layout extends Component {
    static contextType = ShiftsContext

    constructor(props) {
        super(props);
        this.state = {
            trial: false,
            openSubModal: false,
            upgradePlan: false,
            TimesheetModule: this.props.TimesheetModule,
            facilityColor: this.props.facilityColor,
            unreadChats: false,
            facilities:[],
            availableFacilities:[]
        };
        this.handleFacilityChange = this.handleFacilityChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.facilityId !== this.props.facilityId) {
            this.setState({
                nextProps
            }, () => {
                this.checkSub();
            });
        }
        
        if (nextProps.appState !== this.props.appState) {
            this.formatFacilities(this.state.availableFacilities)
        }
        if (nextProps.availableFacilities !== this.props.availableFacilities) {
            this.setState({ availableFacilities: nextProps.availableFacilities })

            this.formatFacilities(nextProps.availableFacilities)
        }
        if (nextProps.TimesheetModule !== this.props.TimesheetModule) {
            this.setState({
                TimesheetModule: nextProps.TimesheetModule
            })
        }
        if (nextProps.facilityColor !== this.props.facilityColor) {
            this.setState({
                facilityColor: nextProps.facilityColor
            });
        }
    }

    componentDidUpdate(prevProps) {
        // Check subscription whenever the route changes
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.checkSub();
        }
    }

    checkSub() {
        if (!this.props.demo && (this.props.user.userType == '1' || this.props.user.userType == '2') && this.props.location.pathname != "/plans") {
            const { setTrial } = this.context
            let trialPeriod = this.props.trialPeriodEnd;
            let trialDate = new Date(trialPeriod);
            let today = new Date();
            if (this.props.planType === "Trial" && trialDate > today) {
                this.setState({ trial: true });
                setTrial(true);
            } else if (this.props.planType === "Free") {
                // Free plan has no Stripe subscription; skip the check.
                this.setState({ trial: false });
                setTrial(false);
            } else {
                axios.get(AUTH_CONFIG.API_URL + "/api/Stripe/CheckSubscription")
                    .then((response) => {
                        if (!response.data) {
                            this.setState({ openSubModal: true });
                        }
                    });
                this.setState({ trial: false });
                setTrial(false);
            }
        }
    }

    getUnreadChats = () => {
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetUnreadChats")
            .then((response) => {
                this.setState({
                    unreadChats: response.data.length > 0
                });
            });
    }

    openUpgradePlan = () => {
        this.setState({
            upgradePlan: true,
        })
    }

    handleFacilityChange(item) {
        this.setState({
            updatingState: true
        });
        const cookies = new Cookies();
        cookies.set('lastFacilityId', item.facilityID, { path: '/' });
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetAppState?facilityId=" + item.facilityID)
            .then((response) => {
                this.props.dispatch(updateUserProfile(response.data.userProfileModel))
                this.props.dispatch(setAppState(response.data.clientViewModel))

                this.setState({
                    facilityName: item.name,
                    updatingState: false
                });
            });
    }

    handleClose = () => {
        this.setState({ upgradePlan: !this.state.upgradePlan });
    };

    toggleNav = () => {
        this.props.dispatch(toggleNav(!this.props.closeNav));
    }

    formatFacilities = (f) => {
        const items = [];

        f.forEach((name, index) => {
            const item = { key: name.facilityID, text: name.name, onClick: () => this.handleFacilityChange(name) };
            items.push(item);
        });
        this.setState({
            facilities: items,
            facilityName: this.props.availableFacilities.filter(x => x.facilityID == this.props.facilityId).map(a => a.name)[0]
        }); 
    }

    // Prefetch the JS chunks for the most-used authenticated routes during
    // browser idle time, so that subsequent navigations resolve from cache and
    // never show the <Suspense> fallback. Role-aware: admins (1/2) and
    // employees (3) prefetch different surfaces. This is purely additive — if
    // the user clicks a route before its chunk has prefetched, React.lazy will
    // still load it normally (and Suspense will briefly show <SiteLoading />).
    //
    // IMPORTANT: we call `.preload()` on the same lazy component references
    // that Routes.js renders (imported from ../lazyRoutes). That shared
    // identity is what lets PendingSwitch see `.loaded === true` after a
    // prefetch completes and skip the loading bar on cached navigations.
    prefetchRouteChunks = () => {
        if (typeof window === 'undefined') return;

        const schedule = (fn) => {
            if (typeof window.requestIdleCallback === 'function') {
                window.requestIdleCallback(fn, { timeout: 3000 });
            } else {
                setTimeout(fn, 1500);
            }
        };

        const storedUserType = localStorage.getItem('user_type');
        let userType = null;
        try {
            const parsed = storedUserType ? JSON.parse(storedUserType) : null;
            userType = parsed != null ? parsed.toString() : null;
        } catch (e) { userType = null; }
        const isEmployee = userType === '3';

        // Lazy-require the shared lazy routes so this file doesn't pay the
        // import cost up-front (and to avoid a circular import at module load).
        const routes = require('../lazyRoutes');

        const adminComponents = [
            routes.SchedulerLayout,
            routes.ShiftLayout,
            routes.UserLayoutScheduler,
            routes.RequestLayout,
            routes.SettingsLayout,
            routes.FormsLayout,
            routes.AuditsLayout,
            routes.TaskManagerLayout,
            routes.Timesheets,
            routes.ScheduleReportLayout,
            routes.ChatLayout,
            routes.Dashboard,
        ];

        const employeeComponents = [
            routes.EmployeeScheduleLayout,
            routes.EmployeeRequestsLayout,
            routes.EmployeeColleagueLayout,
            routes.NotificationsAlertsLayout,
            routes.EmployeeDashboard,
            routes.UserForms,
            routes.ChatLayout,
            routes.QuizzesPage,
        ];

        const components = isEmployee ? employeeComponents : adminComponents;
        // Stagger so prefetches don't all hit the network simultaneously.
        components.forEach((component, i) => {
            if (!component || typeof component.preload !== 'function') return;
            setTimeout(() => schedule(() => {
                try { component.preload().catch(() => { /* ignore */ }); } catch (e) { /* ignore */ }
            }), i * 250);
        });
    };

    componentDidMount() {
        this.setState({ availableFacilities: this.props.availableFacilities })
        this.formatFacilities(this.props.availableFacilities)
        this.checkSub();
        $('.hamburger').click(function () {
            $(this).toggleClass('active');
        }) 
        $('body').addClass(`theme-${this.props.theme}`)

        this.getUnreadChats();
        this.initIntercom();
        this.prefetchRouteChunks();
        const hubConnection = new signalR.HubConnectionBuilder().withUrl(AUTH_CONFIG.API_URL + '/TwilioHub', {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        }).build();
        this.setState({ hubConnection }, () => {
            this.state.hubConnection
                .start()
                .then(() => { })
                .catch(err => { });
            this.state.hubConnection.on('chatMessagesChanged', (response, replyText) => {
                setTimeout(() => {
                    this.getUnreadChats();
                }, 500)
            });
        });
    }

    generateDemoName = () => {
        const firstNames = ['Alex', 'Jordan', 'Morgan', 'Taylor', 'Casey', 'Riley', 'Drew', 'Avery', 'Quinn', 'Jamie'];
        const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Wilson', 'Moore'];
        const first = firstNames[Math.floor(Math.random() * firstNames.length)];
        const last = lastNames[Math.floor(Math.random() * lastNames.length)];
        return `${first} ${last}`;
    }

    initIntercom = () => {
        if (this._intercomInitialized) return;
        const isTrial = this.props.planType === 'Trial';
        const isDemo = !!this.props.demo;
        if (!isTrial && !isDemo) return;

        const user = this.props.user || {};
        let name;
        if (isDemo) {
            name = this.generateDemoName();
        } else {
            name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
        }

        Intercom({
            app_id: INTERCOM_APP_ID,
            user_id: user.userId != null ? String(user.userId) : undefined,
            name: name || undefined,
            email: user.email || undefined,
        });
        this._intercomInitialized = true;
    }

    _getMenu = (props) => {
        // Customize contextual menu with menuAs
        return <ContextualMenu {...props} />;
    }

    openUpgradeModal = () => {
        window.location = AUTH_CONFIG.API_URL + "/api/stripe/create-checkout-session?clientId=" + this.props.clientId + "&email=" + this.props.email
        //this.setState({
        //    upgradePlan: true,
        //    openSubModal: false
        //});
    };

    loadCalendlyAssets = () => {
        if (typeof document === 'undefined') return Promise.resolve();
        // CSS
        if (!document.querySelector(`link[href="${CALENDLY_WIDGET_CSS}"]`)) {
            const link = document.createElement('link');
            link.href = CALENDLY_WIDGET_CSS;
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
        // JS
        if (window.Calendly) return Promise.resolve();
        if (this._calendlyPromise) return this._calendlyPromise;
        this._calendlyPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = CALENDLY_WIDGET_JS;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = (e) => reject(e);
            document.body.appendChild(script);
        });
        return this._calendlyPromise;
    }

    openBookACall = () => {
        this.loadCalendlyAssets().then(() => {
            if (!window.Calendly) return;
            const params = new URLSearchParams();
            const firstName = this.props.user && this.props.user.firstName;
            const lastName = this.props.user && this.props.user.lastName;
            const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
            if (fullName) params.set('name', fullName);
            if (this.props.email) params.set('email', this.props.email);
            params.set('utm_source', 'app');
            params.set('utm_medium', this.props.demo ? 'demo_nav' : 'trial_nav');
            params.set('utm_campaign', 'book_a_call');
            const url = `${CALENDLY_URL}?${params.toString()}`;
            window.Calendly.initPopupWidget({ url });
        }).catch(() => { /* ignore */ });
    }

    toggleChat = () => {
        this.props.dispatch(closeChat(!this.props.closeChat));
    };

    closeQuickStart = () => {
        this.setState({ openQuickStart: false });
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetAppState?facilityId=&url=")
            .then((response) => {
                this.props.dispatch(updateUserProfile(response.data.userProfileModel))
                this.props.dispatch(setAppState(response.data.clientViewModel));
            });
    }

    getLogoSrc = () => {
        const logoPath = this.props.logoUrl;
        if (!logoPath) {
            return '';
        }
        const cdnBase = process.env.REACT_APP_CDN_URL || '';
        const trimmedBase = cdnBase.endsWith('/') ? cdnBase.slice(0, -1) : cdnBase;
        const trimmedPath = logoPath.startsWith('/') ? logoPath.substring(1) : logoPath;
        return `${trimmedBase}/${trimmedPath}`;
    }



    render() {
        const logoSrc = this.getLogoSrc();
        const { showProfilePic, setNavOpen, navOpen } = this.context
        const isAdmin = this.props.user && (this.props.user.userType == '1' || this.props.user.userType == '2');
        return (
            <div className={`main__container flexcolumn ${this.props.closeNav ? 'nav-closed' : 'nav-open'} ${isAdmin && USE_NEW_NAV ? 'admin-nav-active' : ''} theme-${this.props.theme}`}>

                <nav className="navigation-navbar builder-desktop-navbar builder-navbar navbar navbar-default">
                    <div className="container-fluid">
                        <div className="mobile-menu">
                            <Tooltip content="Navigation" relationship="label">
                                <Hamburger onClick={() => setNavOpen(!navOpen)} />
                            </Tooltip>
                        </div>
                        {!(isAdmin && USE_NEW_NAV) &&
                            <div className="navbar-header">
                                <div className="brand">
                                    <a href="/">
                                        <img
                                            src={logoSrc || "https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/circle-100.png"}
                                            style={{ width: 32 }}
                                            className="logo "
                                        />
                                    </a>
                                </div>
                            </div>
                        }


                        <ul className="app-breadcrumbs">
                            {!(isAdmin && USE_NEW_NAV) &&
                                <li className="app-breadcrumbs__apps logo-client-name" role="presentation">
                                    <span className="logo-text">{this.props.clientName}</span>
                                </li>
                            }
                            {!(this.props.type == 'scheduler' && this.props.user.userType == "3") &&
                                <li className="app-breadcrumbs__apps" role="presentation">
                                    {this.state.facilities.length > 1 && <>
                                        <span style={{ color: 'var(--nav-header-text-disabled-color,rgba(0, 0, 0, .38))' }}>/</span>
                                        <span style={{ padding: 0 }}>
                                            <DefaultButton
                                                text={this.state.facilityName}
                                                iconProps={{ iconName: 'POISolid', style: { color: this.state.facilityColor ? this.state.facilityColor : "#FF9800" } }}
                                                className="header-location-selector"
                                                menuProps={{
                                                    items: this.state.facilities,
                                                    directionalHintFixed: true,
                                                    className: 'breadcrumb-dropdown-container',
                                                    calloutProps: {
                                                        calloutMaxHeight: 365,
                                                        styles: {
                                                            root: {
                                                                border: '1px solid rgba(var(--palette-neutral-100), 0.18)',
                                                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2.4px 5.4px 0px, rgba(0, 0, 0, 0.0807) 0px 1.2px 1.6px 0px',
                                                                borderRadius: 5, overflow: 'hidden'
                                                            },
                                                        },
                                                    }
                                                }}
                                                // Optional callback to customize menu rendering
                                                menuAs={this._getMenu}
                                                // By default, the ContextualMenu is re-created each time it's shown and destroyed when closed.
                                                // Uncomment the next line to hide the ContextualMenu but persist it in the DOM instead.
                                                // persistMenu={true}
                                                allowDisabledFocus
                                            />
                                            {this.state.updatingState &&
                                                <Spinner size={SpinnerSize.small} />
                                            }
                                        </span>
                                    </>}
                                    {this.state.facilities.length == 1 && <>
                                        <span className="mr15" style={{ color: 'var(--nav-header-text-disabled-color,rgba(0, 0, 0, .38))' }}>/</span>

                                        <i className="ms-Icon ms-Icon--POISolid mr5" style={{ color: this.state.facilityColor ? this.state.facilityColor : "#FF9800" }}></i> {this.state.facilityName}
                                    </>}
                                </li>
                            }

                        </ul>
                        {!this.props.clientSettings.quickStartDone &&
                            <div className="displayflex aligncenter ">
                                <PrimaryButton
                                    text={"Quick Start Guide"}
                                    style={{ backgroundColor: 'rgb(48 123 129)', border: 'none',color:'#fff' }}
                                    onClick={() => this.props.history.push('/quickstart')}
                                    className=" continue " />
                            </div>
                        }

                        {this.state.trial && isAdmin &&
                            <Fragment>
                                {/*<div className="trial-btn-wrapper">*/}
                                {/*    <div className="trial-lable">Trial</div>*/}
                                {/*</div>*/}
                                <button
                                    type="button"
                                    onClick={this.openBookACall}
                                    className="ms-Button book-call-btn"
                                    style={{
                                        fontSize: 14,
                                        padding: '8px 20px',
                                        marginLeft: 10,
                                        background: 'var(--themePrimary2)',
                                        color: '#fff',
                                        border: '1px solid var(--themePrimary2)',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        alignSelf: 'center',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        lineHeight: 1,
                                    }}>
                                    Book a Call
                                </button>
                                <Link to="/plans" className="ms-Button upgrade-btn" style={{ fontSize: 15, padding: '8px 24px' }}>
                                    Upgrade Now
                                </Link>
                            </Fragment>
                        }
                        
                        {(this.props.planType === 'Free') &&
                            <div className="trial-btn-wrapper ml10">
                                <Link to="/plans" className="ms-Button upgrade-b" style={{ fontSize: 15, padding: '8px 24px' }}>
                                        Upgrade Now
                                    </Link>
                            </div>
                        }

                        {this.props.demo && !this.state.trial && this.props.planType !== 'Free' &&
                            <button
                                type="button"
                                onClick={this.openBookACall}
                                data-tour="book-a-call"
                                className="ms-Button book-call-btn"
                                style={{
                                    fontSize: 14,
                                    padding: '8px 20px',
                                    marginLeft: 10,
                                    background: 'var(--themePrimary2)',
                                    color: '#fff',
                                    border: '1px solid var(--themePrimary2)',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                    alignSelf: 'center',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    lineHeight: 1,
                                }}>
                                Book a Call
                            </button>
                        }

                        {showProfilePic && <ProfileImagePicker />}

                        <ProfileDropdown history={this.props.history} />
                        {/*<Notifications history={this.props.history} />*/}
                        {this.props.coursesModule && <Quizs />}

                        <div className="displayflex aligncenter prelative hide-on-mobile">
                            <IconButton
                                onClick={this.toggleChat}
                                menuProps={this.state.navOptions}
                                className="notification-icon"
                                iconProps={{ iconName: 'Comment' }}
                                onRenderIcon={() => <Chat24Regular style={{ color: 'rgba(var(--palette-neutral-60, 200, 200, 200), 1)' }} />}
                                styles={{
                                    root: { height: '100%', borderRadius: 0 }
                                }}
                            />


                            {this.state.unreadChats &&
                                <span className="notification-bubble"></span>
                            }
                        </div>
                        {this.state.TimesheetModule && <ClockinOptions />}


                    </div>
                </nav>

                <UpgradeModal open={this.state.upgradePlan} handleClose={this.handleClose} />

                <Modal
                    isOpen={this.state.openSubModal}
                    isBlocking={false}
                    className="dark-overlay"
                    styles={{ layer: { zIndex: '3 !important' } }}
                >
                    <div className="" role="document" style={{ width: 450 }}>
                        <div className="pt30 px30">
                            <div style={{ fontSize: 20, fontWeight: '400', color: 'var(--text-primary-color, rgba(0, 0, 0, 0.9))' }}>Your Free Trial Has Expired</div>
                        </div>
                        <div className="px30 py20">
                            <p className="mb10" style={{fontSize:15} }>We hope you've had a great experience with teamsly. We're reaching out to let you know that your free trial has now expired and as a result, your account is now locked.</p>
                            <p style={{ fontSize: 15 }}>If you want to continue using teamsly, you can unlock your account by clicking on the button below and selecting a billing plan that fits your needs.</p>
                        </div>
                        <div className="displayflex p10 pb20" style={{ paddingLeft: '58px', justifyContent: 'flex-end' }}>
                            <Link to="/plans" onClick={() => this.setState({ openSubModal: false})} className="ms-Button action-btn ms-Button--primary mr10" style={{fontSize:15, padding:'8px 24px'} }>
                                View Plans
                            </Link>
                        </div>
                    </div>
                </Modal>




                {!this.props.timeZoneId && (this.props.user.userType == '1' || this.props.user.userType == '2') && <div style={{ marginLeft: 55 }} css={msg}>
                        <MessageBar messageBarType={MessageBarType.severeWarning} className="" isMultiline={true}>Location address missing! Address is required for push notifications to work. <Link to="/settings">
                            Update
                        </Link></MessageBar>
                    </div>
                }

                <div className="displayflex flex1 height100" style={{overflow:'auto'} }>
                    <div className="overflow-container">
                        <NavMenu logoSrc={logoSrc} clientName={this.props.clientName} />
                        {this.props.children}
                    </div>
                    <Snackbar />
                </div>
                <DemoTourRoot />
            </div>

        );
    }
}


const mapStateToProps = state => ({
    user: state.userProfile,
    clientId: state.appState.clientID,
    demo: state.appState.demo,
    email: state.userProfile.email,
    facilityId: state.appState.product.facility.facilityID,
    timeZoneId: state.appState.product.facility.timeZoneId,
    availableFacilities: state.appState.product.availableFacilities,
    appState: state.appState,
    closeNav: state.rootReducer.closeNav,
    closeChat: state.rootReducer.closeChat,
    clientName: state.appState.name,
    logoUrl: state.appState.logoUrl,
    theme: state.rootReducer.theme,
    selectedProduct: state.appState.product.slug,
    TimesheetModule: state.appState.clientSettings.timesheetModule,
    trialPeriodEnd: state.appState.product.facility.subscription.trialPeriodEnd,
    facilityColor: state.appState.product.facility.color,
    clientSettings: state.appState.clientSettings,
    planType: state.appState.planType,
    coursesModule: state.appState.clientSettings.coursesModule
});

export default withRouter(connect(mapStateToProps)(Layout));
